import type { RootState } from '@/app/store';

export const selectCanvasNodes = (state: RootState) =>
  state.canvas.present.nodes;

export const selectCanvasEdges = (state: RootState) =>
  state.canvas.present.edges;

export const selectCanUndo = (state: RootState) =>
  state.canvas.past.length > 0;

export const selectCanRedo = (state: RootState) =>
  state.canvas.future.length > 0;
